var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgReverse(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.60594 8.895L2.52094 10.9875C2.37844 11.1375 2.37844 11.37 2.52094 11.52L4.60594 13.6125C4.83844 13.8525 5.24344 13.68 5.24344 13.35V12H9.75094C10.1634 12 10.5009 11.6625 10.5009 11.25C10.5009 10.8375 10.1634 10.5 9.75094 10.5H5.24344V9.1575C5.24344 8.82 4.83844 8.655 4.60594 8.895ZM15.4884 6.4875L13.4034 4.395C13.1709 4.155 12.7659 4.3275 12.7659 4.6575V6H8.25094C7.83844 6 7.50094 6.3375 7.50094 6.75C7.50094 7.1625 7.83844 7.5 8.25094 7.5H12.7584V8.8425C12.7584 9.18 13.1634 9.345 13.3959 9.105L15.4809 7.0125C15.6309 6.87 15.6309 6.63 15.4884 6.4875Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReverse);
export default __webpack_public_path__ + "static/media/reverse.0cae1acc5598227e6e907eeba0158513.svg";
export { ForwardRef as ReactComponent };